import axios from "axios";
import Swal from "sweetalert2";
import config from "../config";

// This flag prevents a storm of alerts for concurrent requests.
let isHandling401 = false;

const axiosInstance = axios.create({
  baseURL: config.backend_Url,
});

// Request interceptor to add the auth token to headers
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = sessionStorage.getItem("token");
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

//..18.06.2026..//
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
 
    // console.log("TOKEN:", token);
 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
 
    return config;
  },
  (error) => Promise.reject(error)
);

// Centralized function to handle 401 unauthorized errors
const handleUnauthorized = async (message) => {
  if (!isHandling401) {
    isHandling401 = true;

    // Clear auth data from storage
    sessionStorage.clear();
    localStorage.clear();

    // Show an alert to the user
    await Swal.fire({
      title: "Unauthorized",
      text: message || "Your session has expired. Please log in again.",
      icon: "error",
      confirmButtonText: "OK",
      allowOutsideClick: false,
    });

    // Redirect to the login page, replacing the current history entry
    window.location.replace("/login");
  }
};

// Response interceptor to handle global errors
axiosInstance.interceptors.response.use(
  (response) => {
    const { data } = response;
    // The backend sometimes returns 200 OK with an error payload.
    // We need to check for this custom error format.
    if (data && data.status === false && data.subCode === 401) {
      handleUnauthorized(data.message);
      // Reject the promise to ensure it's treated as an error downstream.
      return Promise.reject({ response });
    }
    return response;
  },
  async (error) => {
    // This handles "real" HTTP 401 error statuses.
    if (error.response?.status === 401) {
      handleUnauthorized(error.response?.data?.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;